import { render } from "./SidebarElement.vue?vue&type=template&id=4e769c3e&scoped=true"
import script from "./SidebarElement.vue?vue&type=script&lang=js"
export * from "./SidebarElement.vue?vue&type=script&lang=js"

import "./SidebarElement.vue?vue&type=style&index=0&id=4e769c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e769c3e"]])

export default __exports__